import {QuestionReference, IDependantDescriptor, IQuestion} from '../Question';
import {IPageQuestions, PageQuestions} from './PageQuestions';
import {IScoredQuestion} from "../ScoredQuestion";
import {LoggerFactory} from "../../log/LoggerFactory";
import {QuestionSet} from "../QuestionSet";



export interface IAspectQuestions {

  name: string;
  // firebaseAnswersRoot: string;
  firebaseAspectId: string;
  questions: IQuestion[];
  sections: {
    evaluation: IPageQuestions[];
    portal: IPageQuestions[];
  };
  evaluation?: {
    homePageIconPath: string;
  }
  portal?: {
    navigationMenu: {
      iconImgBase: string
    }
  };
  uuid: string;
  spreadsheetRow?: number;
}

export class EvaluationSection {

  private _log = LoggerFactory.build( 'EvaluationSection' );


  questions: QuestionReference[] = [];
  questionsByKey: {[key: string]: QuestionReference} = {};
  evaluationSections: PageQuestions[] = [];
  portalSections: PageQuestions[] = [];
  homePageIconPath = 'assets/icons/general_hotel_icon.purple.svg';

  static ARRAY = {

    toQuestionSet: ( aspects: EvaluationSection[] ) => {

      const value: IQuestion[] = [];

      for( const aspect of aspects ) {

        for( const question of aspect.questions ) {

          value.push( question.value );
        }
      }

      return new QuestionSet( value );

    },

    /**
     * @deprecated use EvaluationSection.ARRAY.toQuestionSet(), instance is available on the environment
     * @param aspects
     */
    toMapOfKeyToQuestionReference: ( aspects: EvaluationSection[] ) => {

      const answer: { [key: string]: QuestionReference; } = {};

      for( const aspect of aspects ) {

        for( const question of aspect.questions ) {

          answer[question.value.key] = question;
        }
      }

      return answer;
    },

    /**
     * @deprecated use EvaluationSection.ARRAY.toQuestionSet(), instance is available on the environment
     * @param aspects
     */
    toArrayOfQuestions: ( aspects: EvaluationSection[] ): QuestionReference[] => {

      const answer: QuestionReference[] = [];

      for( const aspect of aspects ) {

        for( const question of aspect.questions ) {

          answer.push( question );
        }
      }

      return answer;
    }

  }

  public sectionQuestionsToJson( sectionQuestions: PageQuestions[] ): string  {

    let answer = '[\n';
    for( const section of sectionQuestions ) {
      answer += '{\n'
      answer += `headerText: '${section.value.headerText}',\n`
      answer += `questionKeys: [\n`
      for( const key of section.value.questionKeys ) {


        answer += `'${key}', // ${this.questionsByKey[key].value.label}\n`
      }
      answer += `]\n`
      answer += '},\n'
    }
    answer += ']\n';

    return answer;

  }



  private _validateSections(sections: PageQuestions[], name: string ): number {

    let issues = 0;
    const questionsByKey = Object.assign( {}, this.questionsByKey );
    for( const section of sections ) {

      if( section.value.dependant ) {
        const dependent = this.questionsByKey[section.value.dependant.questionKey];
        if( !dependent ) {

          issues++;
          this._log.error( ` section '${section.value.headerText}' has dependant '${section.value.dependant.questionKey}' not found in questions` );
        }
      }

        for( const questionKey of section.value.questionKeys ) {

        if( questionsByKey[questionKey] ) {
          delete questionsByKey[questionKey];
        } else {

          issues++;
          this._log.error( `questionKey '${questionKey}' in section '${section.value.headerText}' in '${name}' not found in questions` );
        }
      }
    }

    for( const remainingKey in Object.keys( questionsByKey ) ) {

      issues++;
      this._log.error( `remainingKey '${remainingKey}' not found in any sections in '${name}'` );
    }

    return issues;
  }

  private _validateDependents(): number {

    let issues = 0;


    for( const question of this.questions ) {

      const dependant: IDependantDescriptor = question.value.dependant;
      if( dependant ) {

        if( !this.questionsByKey[dependant.questionKey] ) {

          issues++;
          this._log.error( `question with key '${question.value.key}' has dependent with key '${dependant.questionKey}' that does not exist` );
        }
      }
    }

    return issues;
  }



  validate() {

    let issues = this._validateSections( this.evaluationSections, 'evaluationSections' );
    issues += this._validateDependents();
    console.log( `issues: ${issues}` );

  }

  private _init() {

    if( this.value.evaluation && this.value.evaluation.homePageIconPath ) {

      this.homePageIconPath = this.value.evaluation.homePageIconPath;
    }

    // build up all the questions ...
    for( const value of this.value.questions ) {

      const q = new QuestionReference( value );
      this.questions.push( q );
      this.questionsByKey[ q.value.key ] = q;
    }

    // build up the sections ...
    for( const section of this.value.sections.evaluation ) {

      const sectionQuestions = new PageQuestions( section, this.questionsByKey );
      this.evaluationSections.push( sectionQuestions );
    }
    for( const section of this.value.sections.portal ) {

      const sectionQuestions = new PageQuestions( section, this.questionsByKey );
      this.portalSections.push( sectionQuestions );
    }

  }


  private _removePhotoQuestions( otherValue: IAspectQuestions): void {


    {
      const noPhotoQuestions: IScoredQuestion[] = [];
      for( const question of this.questions ) {

        if( !question.isPhoto ) {

          noPhotoQuestions.push( question.value as IScoredQuestion );
        }
      }
      otherValue.questions = noPhotoQuestions;
    }

    {
      const noPhotoEvaluationSections: IPageQuestions[] = [];
      let index = 0;
      for( const evaluationSection of this.evaluationSections ) {

        if( 1 === evaluationSection.questions.length && evaluationSection.questions[0].isPhoto ) {

          // skip
          this._log.debug( `not including this.evaluationSections[${index}]`, evaluationSection );

        } else {

          noPhotoEvaluationSections.push( evaluationSection.value );
        }

        index++;
      }

      otherValue.sections.evaluation = noPhotoEvaluationSections;
    }

  }

  public cloneWithoutPhotos() {

    const json = JSON.stringify( this.value );
    const cloneValue: IAspectQuestions = JSON.parse( json );
    this._removePhotoQuestions( cloneValue );
    return new EvaluationSection( cloneValue );
  }

  constructor( public value: IAspectQuestions ) {

    this._init();
  }

}
